import { ApiError } from '@/api/client';

/**
 * POS csomag-hozzáadási hiba → i18n toast-kulcs (38-kör, #725 fail-closed FE-vetülete).
 *
 * A BE `resolvePosPackagePrice` fail-closed → strukturált `error.code`-ok (`POS_PACKAGE_*`,
 * a #712/#653-minta), a GlobalExceptionFilter `{statusCode:400, code}` wire-shape-én. A régi
 * `fixedPrice ?? 0` némán-0-Ft money-bug helyett a UI most érthető hibát mutat. Code-alapú
 * (message-független, i18n-biztos), NEM message-substring (a bare `throw new Error()`
 * message amúgy sem ér el a FE-ig — 500/INTERNAL_ERROR-ra nyelődik). A TIERED-reject
 * (»POS-on nem eladható«) és a COMPONENT_PRICE_MISSING (»admin: állítsd be az árat«) külön
 * UX-üzenet. Ismeretlen/hiányzó code (hálózati hiba / a BE-PR-merge előtti állapot) →
 * generikus `addFailed` fallback (graceful degradation).
 */
export function posPackageErrorToastKey(error: unknown): string {
  const code = error instanceof ApiError ? error.code : undefined;
  switch (code) {
    case 'POS_PACKAGE_TIERED_NOT_SELLABLE':
      return 'sales.pos.packages.tieredNotSellable';
    case 'POS_PACKAGE_COMPONENT_PRICE_MISSING':
      return 'sales.pos.packages.componentPriceMissing';
    case 'POS_PACKAGE_DISCOUNT_MISSING':
      return 'sales.pos.packages.discountMissing';
    case 'POS_PACKAGE_FIXED_PRICE_MISSING':
      return 'sales.pos.packages.fixedPriceMissing';
    default:
      return 'sales.pos.packages.addFailed';
  }
}
